import React, { useContext, useEffect, useState } from 'react';
import { appContext } from '../../../AppContext';
// import { deleteRecordsByHash, getHistoryRecords } from '../../../services/sql/sqlHelpers';
import { ListOfFiles } from './ListOfFiles';
import LoadingDots from '../../Animations/LoadingDots';
import SelectFilesUpload from './SelectFilesUpload';
import SelectFilesEntry from './SelectFilesEntry';
import { deleteFile } from '../../../services/blockchain';
import { historyService } from '../../../services/historyService';
import { deleteRecordsByHash } from '../../../services/sql/sqlHelpers';

const DragNdrop = ({
  handleFileUpload,
  addingFiles,
  pendingIsOpen,
  showErrorModal,
  isDragging,
  delayDragging,
}) => {
  const { files, setFiles, validateState, setValidatingFile, setDeletingFile } =
    useContext(appContext);

  const [history, setHistory] = useState<HistoryDetails[]>([]); // List of validated history

  /**
   * Fetches the history of validated files and updates the component state.
   *
   * @returns {Promise<void>} A promise that resolves once history is fetched.
   */
  const getHistory = async (): Promise<void> => {
    const result = await historyService.getAllHistory();
    // console.log('result', result);
    setHistory(result);
  };

  // Handles the removal of files from the upload list
  const handleRemoveFile = async (index: number) => {
    if (!validateState) {
      // deleteFile(files[index].fileHash, files[index].file.name);
      setValidatingFile(files[index].file.name);
      setDeletingFile(true);

      try {
        // await historyService.deleteHistory(files[index].id);
        // console.log('Records deleted successfully');
      } catch (error) {
        console.error(error);
      }
      setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
      setValidatingFile('');
      setDeletingFile(false);
    }
  };

  return (
    <>
      {(isDragging || delayDragging) && !showErrorModal && !validateState ? (
        <div className="flex flex-col h-full w-full items-center justify-center gap-2">
          <p className="text-[24px] text-black">Drop your files here</p>
          <p className="text-[16px] text-black font-normal text-center">
            Upload files by dropping them in this window
          </p>
        </div>
      ) : (
        !pendingIsOpen &&
        !showErrorModal && (
          <div
            className={`flex flex-col h-full w-full items-center gap-4 ${
              (files.length <= 0 || addingFiles) && 'justify-center'
            }`}
          >
            {!addingFiles ? (
              <>
                {files.length > 0 ? (
                  <>
                    <SelectFilesUpload
                      handleFileUpload={handleFileUpload}
                      validateState={validateState}
                      files={files}
                    />
                    <ListOfFiles
                      getHistory={getHistory}
                      history={history}
                      handleRemoveFile={handleRemoveFile}
                    />
                  </>
                ) : (
                  <SelectFilesEntry
                    handleFileUpload={handleFileUpload}
                    validateState={validateState}
                    files={files}
                  />
                )}
              </>
            ) : (
              <div className="flex flex-col items-center justify-center gap-2">
                <div className="h-[80px] w-[80px]">
                  <LoadingDots spinningRadius={20} heightWidthPx={'64px'} />
                </div>
                <p className="text-xl font-normal text-core-grey-5">Uploading</p>
              </div>
            )}
          </div>
        )
      )}
    </>
  );
};

export default DragNdrop;
